import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import _ from 'lodash';

import BreadCrumbMenu from '@/components/BreadCrumbMenus/';
import ContentfulImage from '@/components/ContentfulImage';
import Placeholder from '@/components/Placeholder';
import {
  Wrapper,
  Container,
  HeadingSection,
  MainTitleWrapper,
  TitleWrapper,
  MainTitle,
  Title,
  DescriptionWrapper,
  Description,
  ImagesSection,
  ImageWrapper,
  Linker,
  HeroImageCatchCopy,
  HeroImageTitle,
  TermsAndPolicyWrapper,
  TermsAndPolicy,
  NoteWrapper,
  Note,
  ButtonWrapper,
  Button,
  PlaceholderWrapper,
  Content,
  ContentsSection,
  ContentImageWrapper,
  ContentTextButtonWrapper,
  ContentTextButtonContent,
  ContentTitle,
  ContentDescription,
  ContentDescriptionMarkdownLine,
  NoteMarkdownLine,
  SalonLocatorSection,
  SalonLocatorButtonWrapper,
  SalonLocatorMarkdownWrapper,
  SalonLocatorMarkdownLine,
  Hr,
} from '@/pages/HairDiagnosis/HairDiagnosisPage/HairDiagnosisPage.style';
import fetchBeautyContents from '@/redux/actions/beautyContents';
import {
  generateKey,
  getScreenWidth,
  insertNewLine,
  calculateGoldenRatio,
  errorLogger,
  makeCanonicalTagObj,
  makeHreflangTagArr,
} from '@/utils';
import { TABLET_L, MOBILE_PADDING, DESKTOP_MEDIUM } from '@/constants';

class HairDiagnosisPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      // ブラウザ伸縮時に更新されたスクリーンサイズ (スタイル用)
      syncingScreenSize: null,
    };

    // 美容診断 (Beauty Contents) 画面の表示情報を取得する
    const { locale, fetchBeautyContents, updateError } = props;
    fetchBeautyContents(locale)
      .then(res => {
        const { error } = res.action.payload;
        if (error) updateError(error);
        return res;
      })
      .catch(e => {
        errorLogger(e);
      });
  }

  componentDidMount() {
    // ブラウザの横幅をマウスなどによる伸縮に追随させた時に、スクリーンサイズが適切に更新されない場合があるため、リサイズイベントを走らせる
    window.addEventListener('resize', () => this.setState({ syncingScreenSize: getScreenWidth() }));
  }

  render() {
    // 各コンテンツ Placeholder 表示に使用する
    const contentPlaceholderStart = 1;
    const contentPlaceholderEnd = 4;
    // Hero Image 縦幅算出用係数
    const coefficientHeroImage = 1.6;

    const { locale, beautyContents, sitemapInfo, screenSize } = this.props;
    const { syncingScreenSize } = this.state;
    const {
      mainTitle,
      title,
      description,
      hairDiagnosisImage,
      hairDiagnosisLink,
      hairDiagnosisCatchcopy,
      hairDiagnosisTitle,
      colorSimulatorImage,
      colorSimulatorLink,
      colorSimulatorCatchcopy,
      colorSimulatorTitle,
      articleTitle,
      articleDescription,
      contentsList,
      bottomLink,
      bottomCopy,
      metaData,
      termsOfUse,
      privacyPolicy,
      note,
    } = beautyContents;

    // COLOR MIRROR 関連データ
    const colorMirrorContent = _.find(contentsList, item => _.get(item, 'external'));

    return (
      <Wrapper>
        {metaData && (
          <Helmet
            title={_.get(metaData, 'title')}
            link={[
              makeCanonicalTagObj(locale, '/beautyforyou'),
              ...makeHreflangTagArr(metaData.region, '/beautyforyou'),
            ]}
            meta={[
              {
                name: 'description',
                content: _.get(metaData, 'description'),
              },
              {
                name: 'keyword',
                content: _.get(metaData, 'keyword'),
              },
              // TODO: OGP タグは一旦保留 (2020年01月07日)
              // {
              //   property: 'og:url',
              //   content: _.get(metaData, 'url'),
              // },
              // {
              //   property: 'og:type',
              //   content: _.get(metaData, 'type'),
              // },
              // {
              //   property: 'og:title',
              //   content: _.get(metaData, 'title'),
              // },
              // {
              //   property: 'og:image',
              //   content: _.get(metaData, 'image.file.url'),
              // },
              // {
              //   property: 'og:description',
              //   content: _.get(metaData, 'description'),
              // },
              // {
              //   property: 'og:site_name',
              //   content: _.get(metaData, 'siteName'),
              // },
            ]}
          />
        )}
        <Container className={(syncingScreenSize || screenSize) > DESKTOP_MEDIUM && 'desktopMedium'}>
          {/* タイトル見出し部分 */}
          <HeadingSection>
            <MainTitleWrapper>
              {!mainTitle ? (
                <Placeholder
                  w={(syncingScreenSize || screenSize) > TABLET_L ? '400px' : '200px'}
                  h={(syncingScreenSize || screenSize) > TABLET_L ? '50px' : '30px'}
                />
              ) : (
                <MainTitle>{mainTitle}</MainTitle>
              )}
            </MainTitleWrapper>
            <TitleWrapper>
              {!title ? (
                <Placeholder
                  w={(syncingScreenSize || screenSize) > TABLET_L ? '160px' : '200px'}
                  h={(syncingScreenSize || screenSize) > TABLET_L ? '20px' : '14px'}
                />
              ) : (
                <Title>{title}</Title>
              )}
            </TitleWrapper>
            <Hr />
            <DescriptionWrapper>
              {!description ? (
                <Placeholder w="100%" h={(syncingScreenSize || screenSize) > TABLET_L ? '120px' : '84px'} />
              ) : (
                <Description>{description}</Description>
              )}
            </DescriptionWrapper>
          </HeadingSection>

          {/* 美容診断、および COLOR MIRROR メイン画像 */}
          <ImagesSection>
            {!(
              hairDiagnosisImage &&
              _.get(hairDiagnosisImage, 'file.url') &&
              _.get(hairDiagnosisImage, 'title') &&
              hairDiagnosisLink &&
              _.get(hairDiagnosisLink, 'label') &&
              _.get(hairDiagnosisLink, 'url') &&
              hairDiagnosisCatchcopy &&
              hairDiagnosisTitle
            ) ? (
              <React.Fragment>
                <PlaceholderWrapper className="image" direction="column" marginRight="30px">
                  <React.Fragment>
                    <Placeholder
                      w={(syncingScreenSize || screenSize) > TABLET_L ? '512px' : 'calc(100% - 40px)'}
                      h={(syncingScreenSize || screenSize) > TABLET_L ? '319px' : '179px'}
                      m={(syncingScreenSize || screenSize) < TABLET_L && '0 20px 0 20px'}
                    />
                  </React.Fragment>
                  <React.Fragment>
                    <Placeholder
                      w={(syncingScreenSize || screenSize) > TABLET_L ? '338px' : '220px'}
                      h={(syncingScreenSize || screenSize) > TABLET_L ? '72px' : '53px'}
                      m={
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? '37px 87px 20px 87px'
                          : '45px auto 60px calc((100% - 220px) * 0.5)'
                      }
                    />
                  </React.Fragment>
                </PlaceholderWrapper>
              </React.Fragment>
            ) : (
              <ImageWrapper className="hairDiagnosis">
                {!!(_.get(hairDiagnosisImage, 'file.url') && _.get(hairDiagnosisImage, 'file.details')) && (
                  <ContentfulImage
                    src={{ file: hairDiagnosisImage.file }}
                    options={{
                      w:
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? '100%'
                          : `${(syncingScreenSize || screenSize) - MOBILE_PADDING * 2}px`,
                      h:
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? '100%'
                          : `${calculateGoldenRatio({
                              orientation: 'LANDSCAPE',
                              size: (syncingScreenSize || screenSize) - 40,
                              own: 'HORIZONTAL',
                            })}px`,
                      maxHeight: (syncingScreenSize || screenSize) > TABLET_L && '319px',
                      minHeight: (syncingScreenSize || screenSize) > TABLET_L && '319px',
                      size:
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? [0, 0, 525, 650]
                          : [
                              0,
                              0,
                              ((syncingScreenSize || screenSize) - MOBILE_PADDING * 2) / 2,
                              ((syncingScreenSize || screenSize) - MOBILE_PADDING * 2) / 2 * coefficientHeroImage,
                            ],
                      objectFit: 'contain',
                    }}
                  />
                )}
                <HeroImageCatchCopy>{hairDiagnosisCatchcopy}</HeroImageCatchCopy>
                <HeroImageTitle>{hairDiagnosisTitle}</HeroImageTitle>
                <Link to={`/${locale}${hairDiagnosisLink.url}`} href={`/${locale}${hairDiagnosisLink.url}`}>
                  <Button>{hairDiagnosisLink.label}</Button>
                </Link>
              </ImageWrapper>
            )}
            {!(
              colorSimulatorImage &&
              _.get(colorSimulatorImage, 'file.url') &&
              _.get(colorSimulatorImage, 'title') &&
              colorSimulatorLink &&
              _.get(colorSimulatorLink, 'url') &&
              _.get(colorSimulatorLink, 'label') &&
              locale &&
              colorSimulatorCatchcopy &&
              colorSimulatorTitle &&
              termsOfUse &&
              _.get(termsOfUse, 'url') &&
              _.get(termsOfUse, 'label') &&
              privacyPolicy &&
              _.get(privacyPolicy, 'url') &&
              _.get(privacyPolicy, 'label') &&
              note
            ) ? (
              <PlaceholderWrapper className="image" direction="column">
                <React.Fragment>
                  <Placeholder
                    w={(syncingScreenSize || screenSize) > TABLET_L ? '512px' : 'calc(100% - 40px)'}
                    h={(syncingScreenSize || screenSize) > TABLET_L ? '319px' : '179px'}
                    m={(syncingScreenSize || screenSize) < TABLET_L && '0 20px 0 20px'}
                  />
                </React.Fragment>
                <React.Fragment>
                  <Placeholder
                    w={(syncingScreenSize || screenSize) > TABLET_L ? '338px' : '220px'}
                    h={(syncingScreenSize || screenSize) > TABLET_L ? '72px' : '53px'}
                    m={
                      (syncingScreenSize || screenSize) > TABLET_L
                        ? '37px 87px 20px 87px'
                        : '45px auto 20px calc((100% - 220px) * 0.5)'
                    }
                  />
                </React.Fragment>
                <PlaceholderWrapper className="terms" direction="row">
                  <Placeholder w="40px" h="15px" m="0 8px 0 0" />
                  <Placeholder w="40px" h="15px" m="0 0 0 8px" />
                </PlaceholderWrapper>
                <Placeholder
                  w={(syncingScreenSize || screenSize) > TABLET_L ? '512px' : '90%'}
                  h="15px"
                  m="20px 10px 0 10px"
                />
              </PlaceholderWrapper>
            ) : (
              <ImageWrapper className="colorSimulator">
                {!!(_.get(colorSimulatorImage, 'file.url') && _.get(colorSimulatorImage, 'file.details')) && (
                  <ContentfulImage
                    src={{ file: colorSimulatorImage.file }}
                    options={{
                      w:
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? '100%'
                          : `${(syncingScreenSize || screenSize) - MOBILE_PADDING * 2}px`,
                      h:
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? '100%'
                          : `${calculateGoldenRatio({
                              orientation: 'LANDSCAPE',
                              size: (syncingScreenSize || screenSize) - 40,
                              own: 'HORIZONTAL',
                            })}px`,
                      maxHeight: (syncingScreenSize || screenSize) > TABLET_L && '319px',
                      minHeight: (syncingScreenSize || screenSize) > TABLET_L && '319px',
                      size:
                        (syncingScreenSize || screenSize) > TABLET_L
                          ? [0, 0, 525, 650]
                          : [
                              0,
                              0,
                              ((syncingScreenSize || screenSize) - MOBILE_PADDING * 2) / 2,
                              ((syncingScreenSize || screenSize) - MOBILE_PADDING * 2) / 2 * coefficientHeroImage,
                            ],
                      objectFit: 'contain',
                    }}
                  />
                )}
                <HeroImageCatchCopy>{colorSimulatorCatchcopy}</HeroImageCatchCopy>
                <HeroImageTitle>{colorSimulatorTitle}</HeroImageTitle>
                <Linker href={colorSimulatorLink.url} target="_blank">
                  <Button>{colorSimulatorLink.label}</Button>
                </Linker>
                <TermsAndPolicyWrapper>
                  <a href={termsOfUse.url} target="_blank">
                    <TermsAndPolicy paddingRight="16">{termsOfUse.label}</TermsAndPolicy>
                  </a>
                  <a href={privacyPolicy.url} target="_blank">
                    <TermsAndPolicy paddingRight="0">{privacyPolicy.label}</TermsAndPolicy>
                  </a>
                </TermsAndPolicyWrapper>
                <NoteWrapper>
                  <Note>{note}</Note>
                </NoteWrapper>
              </ImageWrapper>
            )}
          </ImagesSection>

          {/* 記事タイトル見出し部分 */}
          <HeadingSection>
            <TitleWrapper>
              {!articleTitle ? (
                <Placeholder
                  w={(syncingScreenSize || screenSize) > TABLET_L ? '160px' : '200px'}
                  h={(syncingScreenSize || screenSize) > TABLET_L ? '20px' : '14px'}
                />
              ) : (
                <Title>{articleTitle}</Title>
              )}
            </TitleWrapper>
            <Hr />
            <DescriptionWrapper>
              {!articleDescription ? (
                <Placeholder w="100%" h={(syncingScreenSize || screenSize) > TABLET_L ? '120px' : '84px'} />
              ) : (
                <Description>{articleDescription}</Description>
              )}
            </DescriptionWrapper>
          </HeadingSection>

          {/* 各コンテンツ */}
          <ContentsSection>
            {!contentsList && !_.find(contentsList, item => _.get(item, 'image.file.url')) ? (
              new Array(contentPlaceholderEnd - contentPlaceholderStart).fill(null).map((item, index) => (
                <PlaceholderWrapper key={generateKey('content-placeholder', index)}>
                  <PlaceholderWrapper
                    className={`contentImagePlaceholder ${index === 2 && 'isLast'}`}
                    left={index % 2 !== 0}
                  >
                    <Placeholder
                      w="100%"
                      h="100%"
                      m={(syncingScreenSize || screenSize) > TABLET_L ? '0 0 0 0' : '0 0 20px 0'}
                    />
                  </PlaceholderWrapper>
                  <PlaceholderWrapper className="contentPlaceholder" left={index % 2 !== 0}>
                    <PlaceholderWrapper className="contentPlaceholderChild" spContentPlaceholderHeight="112px">
                      {/* Placeholder > title */}
                      <PlaceholderWrapper>
                        <Placeholder
                          w={(syncingScreenSize || screenSize) > TABLET_L ? '100%' : 'calc(100% - 40px)'}
                          h={(syncingScreenSize || screenSize) > TABLET_L ? '45px' : '36px'}
                          m={(syncingScreenSize || screenSize) > TABLET_L ? '0 0 20px 0' : '0 20px 20px 20px'}
                        />
                      </PlaceholderWrapper>
                      {/* Placeholder > description */}
                      <PlaceholderWrapper>
                        <Placeholder
                          w={(syncingScreenSize || screenSize) > TABLET_L ? '100%' : 'calc(100% - 40px)'}
                          h={(syncingScreenSize || screenSize) > TABLET_L ? '45px' : '36px'}
                          m={(syncingScreenSize || screenSize) > TABLET_L ? '0 0 42px 0' : '0 20px 20px 20px'}
                        />
                      </PlaceholderWrapper>
                    </PlaceholderWrapper>
                    {/* Placeholder > 詳細ボタン */}
                    <PlaceholderWrapper className="contentPlaceholderChild" spButtonPlaceholderHeight="48px">
                      <Placeholder
                        w={(syncingScreenSize || screenSize) > TABLET_L ? '338px' : '220px'}
                        h={(syncingScreenSize || screenSize) > TABLET_L ? '72px' : '53px'}
                        m={(syncingScreenSize || screenSize) > TABLET_L ? '0 30px 0 0' : '0 0 0 0'}
                      />
                    </PlaceholderWrapper>
                  </PlaceholderWrapper>
                </PlaceholderWrapper>
              ))
            ) : (
              <React.Fragment>
                {contentsList.map(
                  ({ title, description, image, buttonText, url, contentType, slug, external }, index) => (
                    <Content key={generateKey('content', index)}>
                      <ContentImageWrapper className="contentImage" left={index % 2 !== 0}>
                        <ContentfulImage
                          src={image}
                          options={{
                            w:
                              (syncingScreenSize || screenSize) > TABLET_L
                                ? `${(syncingScreenSize || screenSize) / 2}px`
                                : `${syncingScreenSize || screenSize}px`,
                            aspectRatio: 4 / 3,
                          }}
                        />
                      </ContentImageWrapper>
                      <ContentTextButtonWrapper
                        left={index % 2 !== 0}
                        className={(syncingScreenSize || screenSize) > DESKTOP_MEDIUM && 'desktopMedium'}
                      >
                        <ContentTextButtonContent>
                          <ContentTitle left={index % 2 !== 0}>{title}</ContentTitle>
                          <ContentDescription left={index % 2 !== 0}>
                            {insertNewLine({
                              key: 'content-description',
                              description,
                              component: ContentDescriptionMarkdownLine,
                            })}
                          </ContentDescription>
                          {!!(contentType === 'articlePage' && slug) && (
                            <ButtonWrapper>
                              <Link to={`/${locale}/beautyforyou/${slug}`} href={`/${locale}/beautyforyou/${slug}`}>
                                <Button>{buttonText}</Button>
                              </Link>
                            </ButtonWrapper>
                          )}
                          {!!(contentType === 'beautyContentsLink' && url) && (
                            <ButtonWrapper>
                              {external ? (
                                <Linker href={url} target="_blank">
                                  <Button>{buttonText}</Button>
                                </Linker>
                              ) : (
                                <Link to={`/${locale}${url}`} href={`/${locale}${url}`}>
                                  <Button>{buttonText}</Button>
                                </Link>
                              )}
                            </ButtonWrapper>
                          )}
                          {external && (
                            <React.Fragment>
                              <TermsAndPolicyWrapper>
                                <Linker
                                  href={colorMirrorContent.textLink[1].url}
                                  target="_blank"
                                  className="termsAndPolicy"
                                >
                                  <TermsAndPolicy
                                    paddingRight={(syncingScreenSize || screenSize) > TABLET_L ? '19' : '23'}
                                  >
                                    {colorMirrorContent.textLink[1].label}
                                  </TermsAndPolicy>
                                </Linker>
                                <Linker
                                  href={colorMirrorContent.textLink[0].url}
                                  target="_blank"
                                  className="termsAndPolicy"
                                >
                                  <TermsAndPolicy paddingRight="0">
                                    {colorMirrorContent.textLink[0].label}
                                  </TermsAndPolicy>
                                </Linker>
                              </TermsAndPolicyWrapper>
                              <NoteWrapper>
                                <Note>
                                  {insertNewLine({
                                    key: 'note-partial-line',
                                    description: colorMirrorContent.note,
                                    component: NoteMarkdownLine,
                                  })}
                                </Note>
                              </NoteWrapper>
                            </React.Fragment>
                          )}
                        </ContentTextButtonContent>
                      </ContentTextButtonWrapper>
                    </Content>
                  )
                )}
              </React.Fragment>
            )}
          </ContentsSection>

          {/* サロン検索リンク */}
          {!(locale && bottomLink && _.get(bottomLink, 'label') && _.get(bottomLink, 'url') && bottomCopy) ? (
            <Placeholder
              w="100%"
              h={(syncingScreenSize || screenSize) > TABLET_L ? '316px' : '278px'}
              m={(syncingScreenSize || screenSize) > TABLET_L ? '0 0 40px 0' : '0 0 30px 0'}
            />
          ) : (
            <SalonLocatorSection>
              <SalonLocatorMarkdownWrapper>
                {insertNewLine({
                  key: 'bottom-copy-partial-line',
                  description: bottomCopy,
                  component: SalonLocatorMarkdownLine,
                })}
              </SalonLocatorMarkdownWrapper>
              <SalonLocatorButtonWrapper>
                <Link to={`/${locale}${bottomLink.url}`} href={`${locale}${bottomLink.url}`}>
                  <Button>{bottomLink.label}</Button>
                </Link>
              </SalonLocatorButtonWrapper>
            </SalonLocatorSection>
          )}
        </Container>
        {!(locale && sitemapInfo && _.get(sitemapInfo, 'label')) ? (
          <Placeholder
            w="200px"
            h="24px"
            m={(syncingScreenSize || screenSize) > TABLET_L ? '0 0 20px 40px' : '0 0 20px 20px'}
          />
        ) : (
          <BreadCrumbMenu
            currentPath={`https://www.shiseido-professional.com/${locale}/beautyforyou`}
            items={[
              {
                name: 'TOP',
                path: `/${locale}/`,
              },
              {
                name: sitemapInfo.label,
                path: null,
              },
            ]}
          />
        )}
      </Wrapper>
    );
  }
}

HairDiagnosisPage.defaultProps = {
  screenSize: null,
};

HairDiagnosisPage.propTypes = {
  locale: PropTypes.string.isRequired,
  // 美容診断 (Beauty Consultation) 画面の表示情報を取得する
  fetchBeautyContents: PropTypes.func.isRequired,
  // サイトマップ情報 (パンくずリストに必要な情報を含む)
  sitemapInfo: PropTypes.shape({}).isRequired,
  // 美容診断 (Beauty Contents) 画面の表示情報
  beautyContents: PropTypes.shape({
    // タイトル (見出し)
    title: PropTypes.string,
    // タイトル (見出し) 右横の説明文
    description: PropTypes.string,
    // Hair Diagnosis 画像情報
    hairDiagnosisImage: PropTypes.shape({}),
    // Color Simulator 画像情報
    colorSimulatorImage: PropTypes.shape({}),
    // Hair Diagnosis ボタンの文言、URL
    hairDiagnosisLinks: PropTypes.shape({}),
    // Color Simulator ボタンの文言、URL
    colorSimulatorLink: PropTypes.shape({}),
  }).isRequired,
  // スクリーンサイズ
  screenSize: PropTypes.number,
  updateError: PropTypes.func.isRequired,
};

const mapState = ({ locale, beautyContents, siteOptions }) => ({
  locale,
  beautyContents,
  // サイトマップ情報をキャッシュしておく
  sitemapInfo: siteOptions.sitemap ? _.find(siteOptions.sitemap, item => item.url === '/beautyforyou') : {},
  // スクリーンサイズを実寸で取得する
  screenSize: getScreenWidth(),
});

const mapDispatch = dispatch => ({
  fetchBeautyContents: locale => dispatch(fetchBeautyContents(locale)),
  updateError: error => dispatch({ type: 'UPDATE_ERROR', error }),
});

export default connect(mapState, mapDispatch)(HairDiagnosisPage);



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisPage/HairDiagnosisPage.js